import React from 'react'
import {
    useRouteError,
    isRouteErrorResponse,
} from 'react-router-dom'

export default function ErrorView() {

    const error = useRouteError()
    console.error(error)

    if (!isRouteErrorResponse(error)) {
        return (
            <div id="error-page">
                <h1>Něco se nezdařilo</h1>
                <p>V aplikaci došlo k neočekávané chybě.</p>
            </div>
        )
    }

    return (
        <div id="error-page">
            <h1>Nepovedlo se načíst stránku</h1>
            <p>Došlo k problému, kvůli kterému nebylo možné načíst stránku. Případný chybový kód je níže.</p>
            <p>
                {error.status &&
                    <i>{error.status} - </i>
                }
                <i>{error.statusText || error.data.message}</i>
            </p>
        </div>
    )
}
